import { Component } from '@angular/core';
import { ChartConfiguration } from 'chart.js';

@Component({
  selector: 'app-merchant-analytics',
  templateUrl: './merchant-analytics.component.html',
  styleUrls: ['./merchant-analytics.component.css'],
})
export class MerchantAnalyticsComponent {
  //Transaction Volume Line Chart

  public transcationLineChartData: ChartConfiguration<'line'>['data'] = {
    labels: ['05:00', '10:00', '15:00', '20:00', '25:00', '30:00'],
    datasets: [
      {
        data: [0.1, 0.2, 0.3, 0.1, 0.2],
        label: 'Series B',
        borderColor: 'purple',
        backgroundColor: 'transparent',
        borderWidth: 4,
        tension: 0.4,
      },
    ],
  };

  //Revenue Analysis Line Chart

  public revenueAnalysisChartData: ChartConfiguration<'line'>['data'] = {
    labels: ['05:00', '10:00', '15:00', '20:00', '25:00', '30:00'],
    datasets: [
      {
        data: [0.1, 0.2, 0.3, 0.1, 0.2],
        label: 'Series B',
        borderColor: 'purple',
        backgroundColor: 'transparent',
        borderWidth: 4,
        tension: 0.4,
      },
    ],
  };

  //Scheme Performance Line Chart

  public schemePerformanceChartData: ChartConfiguration<'line'>['data'] = {
    labels: ['05:00', '10:00', '15:00', '20:00', '25:00', '30:00'],
    datasets: [
      {
        data: [0.1, 0.2, 0.3, 0.1, 0.2],
        label: 'Series B',
        borderColor: 'purple',
        backgroundColor: 'transparent',
        borderWidth: 4,
        tension: 0.4,
      },
    ],
  };

  //Customer Profile Bar Chart Data

  public customerProfileChartData: ChartConfiguration<'bar'>['data'] = {
    labels: ['Error 1', 'Error 2', 'Error 3'],
    datasets: [
      { data: [3, 4.5, 7], label: 'Error A', backgroundColor: '#0058e9' },
    ],
  };

  //Service Request Bar Chart Data

  public serviceRequestChartData: ChartConfiguration<'bar'>['data'] = {
    labels: ['Service 1', 'Service 2', 'Service 3'],
    datasets: [
      { data: [3, 4.5, 7], label: 'Service A', backgroundColor: '#0058e9' },
    ],
  };
}
